import React from 'react';
import { UnitListFragment } from '../generated/graphql';
import { Box, Card, CardActionArea, CardHeader, CardMedia, Chip, Stack } from '@mui/material';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';

interface UnitCardProps {
  unit: UnitListFragment;
  width?: number;
  height?: number;
  onClick: () => void;
}

export function UnitCard(props: UnitCardProps) {
  const { unit, onClick, width = 300, height = 285 } = props;
  const photoHeight = 140;

  return (
    <Card sx={{ width, height, position: 'relative' }}>
      <CardActionArea onClick={onClick}>
        {unit.coverPhoto?.urlXs ? (
          <CardMedia
            sx={{ height: photoHeight }}
            image={unit.coverPhoto?.urlXs ?? undefined}
            title={unit.coverPhoto?.desc ?? undefined}
          />
        ) : (
          <Box
            width={width}
            height={photoHeight}
            sx={{ backgroundColor: 'lightgray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <NoPhotographyIcon fontSize="large" />
          </Box>
        )}

        <Stack direction="row" spacing={1} sx={{ position: 'absolute', top: 8, right: 8 }}>
          {unit.status === 'not_renting' && <Chip label="Neprenajímaná" color="warning" size="small" />}
          {unit.status === 'archived' && (
            <Chip label="Archivovaná" sx={{ bgcolor: 'grey.500', color: 'white' }} size="small" />
          )}
        </Stack>

        <CardHeader title={unit.name} subheader={unit.address} />
      </CardActionArea>
    </Card>
  );
}
